(function($) {
	$.validator.setDefaults({
		    highlight: function(element) {
		        $(element).closest('.form-group').addClass('has-error');
		    },
		    unhighlight: function(element) {
		        $(element).closest('.form-group').removeClass('has-error');
		    },
		    errorElement: 'span',
		    errorClass: 'help-block',
		    errorPlacement: function(error, element) {
		        if(element.closest('.input-group').length) {
		            error.insertAfter(element.closest('.input-group'));
		        } else {
		            error.insertAfter(element);
		        }
		    },
		});

	// Aggiungo un controllo per i valori che non devono essere vuoti
    jQuery.validator.addClassRules("validate-noempty", {
  		required: true,
  		normalizer: function(value) {
    		return $.trim(value);
  		},
	});

	jQuery.extend(jQuery.validator.messages, {
	    required: validationMessage.required,
	    remote: validationMessage.remote,
	    email: validationMessage.email,
	    url: validationMessage.url,
	    date: validationMessage.date,
	    dateISO: validationMessage.dateISO,
	    number: validationMessage.number,
	    digits: validationMessage.digits,
	    creditcard: validationMessage.creditcard,
	    equalTo: validationMessage.equalTo,
	    accept: validationMessage.accept,
	    maxlength: jQuery.validator.format(validationMessage.maxlength),
	    minlength: jQuery.validator.format(validationMessage.minlength),
	    rangelength: jQuery.validator.format(validationMessage.rangelength),
	    range: jQuery.validator.format(validationMessage.range),
	    max: jQuery.validator.format(validationMessage.max),
	    min: jQuery.validator.format(validationMessage.min),
	});
  	
  	$('#form-agent-registration').validate({
  		rules: {
  			'user_telephone' : {
  				number: true,
  			},
  			'user_fax' : {
  				number: true,
  			},
	        'user_email_confirm': {
	        	equalTo: '#user_email'
	        }    
        }
  	});

  	$('#form-user-registration').validate({
  		rules: {
  			'user_telephone' : {
  				number: true,
  			},
  			'user_fax' : {
  				number: true,
  			},
	        'user_email_confirm': {
	        	equalTo: '#user_email'
	        }
        }
  	});

  	$('#form-reservation').validate({});

  	$('#ReservationSerchTicket').validate({});

  	$('#user-login-form').validate({});
  	$('#modal-login-form').validate({});

  	$('#gbo-booking-details')

  	$('#gbo-booking-details').validate({
  		rules: {
  			'referent-telephone' : {
  				number: true,
  			},
	        'referent-email-confirm': {
	        	equalTo: '#referent-email',
	        },
	        'primiposti_a': {
	        	digits: true,
	        },
	        'primiposti_r': {
	        	digits: true,
			},
			'newsletter': {
				required:true,
			}
        }
  	});
})(jQuery);